import { map, times } from 'lodash';
import { spacing, spacingKeys } from 'styles/spacing';

const MAX_SPACING_SIZE_TIMES = 11;

/* GENERATE SMALL SPACING CLASSES
 * Check the classes generated in SpacingGlobal.md
 * multiple: 4px
 * It will follow this pattern: {varian}{direction}-{size}
 * variants: [m, p]
 * directions [t, b, l, r, x, y]
 * size [0, 1, 2, ..., 10]
 */
export const getSmallSpacingClasses = (): string => {
  return map(spacingKeys, (key: string) =>
    map(
      times(MAX_SPACING_SIZE_TIMES),
      (number: number) => `.${key}-${number} { ${spacing(key, number, false, true)} }`
    ).join('')
  ).join('');
};

/* GENERATE LARGE SPACING CLASSES
 * Check the classes generated in SpacingGlobal.md
 * multiple: 16px
 * It will follow this pattern: {varian}-{direction}-{size}
 * variants: [m, p]
 * directions: [a, t, b, l, r, x, y]
 * size: [0, 1, 2, 3, 4]
 */
// sonar-ignore-start
export const getLargeSpacingClasses = (): string => {
  return map(['m', 'p'], (v: string) =>
    map(
      times(5),
      (number: number) =>
        `.${v}-t-${number} { ${spacing(`${v}t`, number * 4, false, true)}}
       .${v}-l-${number} { ${spacing(`${v}l`, number * 4, false, true)}}
       .${v}-b-${number} { ${spacing(`${v}b`, number * 4, false, true)}}
       .${v}-r-${number} { ${spacing(`${v}r`, number * 4, false, true)}}
       .${v}-x-${number} { ${spacing(`${v}x`, number * 4, false, true)}}
       .${v}-y-${number} { ${spacing(`${v}y`, number * 4, false, true)}}
       .${v}-a-${number} { ${spacing(`${v}`, number * 4, false, true)}}
       `
    ).join('')
  ).join('');
};
// sonar-ignore-end
